webpackJsonp([35783957827783],{

/***/ 311:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fade = function (_Component) {
	  _inherits(Fade, _Component);
	
	  function Fade(props) {
	    _classCallCheck(this, Fade);
	
	    var _this = _possibleConstructorReturn(this, (Fade.__proto__ || Object.getPrototypeOf(Fade)).call(this, props));
	
	    _this.state = {
	      images: []
	    };
	    _this.imageRefs = [];
	    _this.width = 0;
	    _this.height = 0;
	    _this.timeout = null;
	    _this.imageContainer = null;
	    _this.getImageDim = _this.getImageDim.bind(_this);
	    return _this;
	  }
	
	  _createClass(Fade, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.timeout = setTimeout(function () {
	        return _this2.fadeImages('next');
	      }, this.props.duration);
	      this.setState({
	        images: this.props.images.reverse()
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.width = document.querySelector('.react-slideshow-fade-wrapper').clientWidth;
	      this.applyStyle();
	      this.addResizeListener();
	    }
	  }, {
	    key: 'getImageDim',
	    value: function getImageDim() {
	      this.height = this.imageContainer.children[0].clientHeight;
	      this.imageContainer.style.height = this.height + 'px';
	    }
	  }, {
	    key: 'addResizeListener',
	    value: function addResizeListener() {
	      var _this3 = this;
	
	      window.addEventListener('resize', function () {
	        _this3.width = document.querySelector('.react-slideshow-fade-wrapper').clientWidth;
	        _this3.applyStyle();
	      });
	    }
	  }, {
	    key: 'applyStyle',
	    value: function applyStyle() {
	      var _this4 = this;
	
	      this.imageRefs.forEach(function (eachImage, index) {
	        eachImage.style.width = _this4.width + 'px';
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var type = this.props.type;
	      var images = this.state.images;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-slideshow-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this5.fadeImages('prev');
	            } },
	          ' ',
	          '<',
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'react-slideshow-fade-wrapper ' + type },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'images-wrap',
	              ref: function ref(wrap) {
	                return _this5.imageContainer = wrap;
	              }
	            },
	            images.map(function (each, key) {
	              return _react2.default.createElement(
	                'div',
	                {
	                  ref: function ref(el) {
	                    _this5.imageRefs.push(el);
	                  },
	                  onLoad: key === 0 ? _this5.getImageDim : null,
	                  'data-index': key,
	                  key: key
	                },
	                _react2.default.createElement('img', { alt: '', src: each })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this5.fadeImages('next');
	            } },
	          ' ',
	          '>',
	          ' '
	        )
	      );
	    }
	  }, {
	    key: 'fadeImages',
	    value: function fadeImages(type) {
	      var _this6 = this;
	
	      var images = this.state.images;
	
	      var newImageArr = [];
	      clearTimeout(this.timeout);
	      var lastImage = this.imageContainer.children[images.length - 1];
	      if (type === 'prev') {
	        newImageArr = images.slice(1);
	        newImageArr.splice(newImageArr.length - 1, 0, images[0]);
	        this.setState({ images: newImageArr });
	        newImageArr = images.slice(1, images.length);
	        newImageArr.splice(newImageArr.length, 0, images[0]);
	      } else {
	        newImageArr = [images[images.length - 1]].concat(images.slice(0, images.length - 1));
	      }
	      lastImage.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
	      lastImage.style.opacity = '0';
	      setTimeout(function () {
	        lastImage.style.opacity = '1';
	        lastImage.style.transition = 'none';
	        _this6.timeout = setTimeout(function () {
	          return _this6.fadeImages('next');
	        }, _this6.props.duration);
	        _this6.setState({ images: newImageArr });
	      }, this.props.transitionDuration);
	    }
	  }]);
	
	  return Fade;
	}(_react.Component);
	
	Fade.defaultProps = {
	  duration: 5000,
	  transitionDuration: 1000
	};
	
	Fade.propTypes = {
	  images: _propTypes2.default.array.isRequired,
	  duration: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	};
	exports.default = Fade;

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slideshow = function (_Component) {
	  _inherits(Slideshow, _Component);
	
	  function Slideshow(props) {
	    _classCallCheck(this, Slideshow);
	
	    var _this = _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call(this, props));
	
	    _this.state = {
	      index: 0
	    };
	    _this.width = 0;
	    _this.imageContainer = null;
	    _this.timeout = null;
	    return _this;
	  }
	
	  _createClass(Slideshow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.allImages = document.querySelectorAll('.images-wrap div');
	      this.width = document.querySelector('.react-slideshow-wrapper').clientWidth;
	      this.setWidth();
	      this.addResizeListener();
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var fullwidth = this.width * (this.props.images.length + 2);
	      this.imageContainer.style.width = fullwidth + 'px';
	      this.imageContainer.style.transform = 'translate(-' + this.width * (this.state.index + 1) + 'px)';
	      this.applySlideStyle();
	    }
	  }, {
	    key: 'addResizeListener',
	    value: function addResizeListener() {
	      var _this2 = this;
	
	      window.addEventListener('resize', function () {
	        _this2.width = document.querySelector('.react-slideshow-wrapper').clientWidth;
	        _this2.setWidth();
	      });
	    }
	  }, {
	    key: 'applySlideStyle',
	    value: function applySlideStyle() {
	      var _this3 = this;
	
	      this.allImages.forEach(function (eachImage, index) {
	        eachImage.style.width = _this3.width + 'px';
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          images = _props.images,
	          duration = _props.duration;
	      var index = this.state.index;
	
	      var style = {
	        transform: 'translate(-' + (index + 1) * this.width + 'px)'
	      };
	      this.timeout = setTimeout(function () {
	        return _this4.slideImages('next');
	      }, duration);
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-slideshow-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this4.slideImages('prev');
	            } },
	          ' ',
	          '<',
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'react-slideshow-wrapper slide' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'images-wrap',
	              style: style,
	              ref: function ref(wrap) {
	                return _this4.imageContainer = wrap;
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { 'data-index': '-1' },
	              _react2.default.createElement('img', { alt: '', src: images[images.length - 1] })
	            ),
	            images.map(function (each, key) {
	              return _react2.default.createElement(
	                'div',
	                {
	                  'data-index': key,
	                  key: key,
	                  className: key === index ? 'active' : ''
	                },
	                _react2.default.createElement('img', { alt: '', src: each })
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              { 'data-index': '-1' },
	              _react2.default.createElement('img', { alt: '', src: images[0] })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this4.slideImages('next');
	            } },
	          ' ',
	          '>',
	          ' '
	        )
	      );
	    }
	  }, {
	    key: 'slideImages',
	    value: function slideImages(type) {
	      var _this5 = this;
	
	      var index = this.state.index;
	      var images = this.props.images;
	
	      clearTimeout(this.timeout);
	      index = type === 'next' ? index + 1 : index - 1;
	      this.imageContainer.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
	      this.imageContainer.style.transform = 'translate(-' + this.width * (index + 1) + 'px)';
	      setTimeout(function () {
	        _this5.imageContainer.style.transition = 'none';
	        _this5.setState({
	          index: index < 0 ? images.length - 1 : index >= images.length ? 0 : index
	        });
	      }, this.props.transitionDuration);
	    }
	  }]);
	
	  return Slideshow;
	}(_react.Component);
	
	Slideshow.defaultProps = {
	  duration: 5000,
	  transitionDuration: 1000
	};
	
	Slideshow.propTypes = {
	  images: _propTypes2.default.array.isRequired,
	  duration: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	};
	exports.default = Slideshow;

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Zoom = function (_Component) {
	  _inherits(Zoom, _Component);
	
	  function Zoom(props) {
	    _classCallCheck(this, Zoom);
	
	    var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this, props));
	
	    _this.state = {
	      images: []
	    };
	    _this.imageRefs = [];
	    _this.width = 0;
	    _this.height = 0;
	    _this.timeout = null;
	    _this.imageContainer = null;
	    _this.getImageDim = _this.getImageDim.bind(_this);
	    return _this;
	  }
	
	  _createClass(Zoom, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.timeout = setTimeout(function () {
	        return _this2.fadeImages('next');
	      }, this.props.duration);
	      this.setState({
	        images: this.props.images.reverse()
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.width = document.querySelector('.react-slideshow-zoom-wrapper').clientWidth;
	      this.applyStyle();
	      this.addResizeListener();
	    }
	  }, {
	    key: 'getImageDim',
	    value: function getImageDim() {
	      this.height = this.imageContainer.children[0].clientHeight;
	      this.imageContainer.style.height = this.height + 'px';
	    }
	  }, {
	    key: 'addResizeListener',
	    value: function addResizeListener() {
	      var _this3 = this;
	
	      window.addEventListener('resize', function () {
	        _this3.width = document.querySelector('.react-slideshow-zoom-wrapper').clientWidth;
	        _this3.applyStyle();
	      });
	    }
	  }, {
	    key: 'applyStyle',
	    value: function applyStyle() {
	      var _this4 = this;
	
	      this.imageRefs.forEach(function (eachImage, index) {
	        eachImage.style.width = _this4.width + 'px';
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var type = this.props.type;
	      var images = this.state.images;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-slideshow-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this5.fadeImages('prev');
	            } },
	          ' ',
	          '<',
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'react-slideshow-zoom-wrapper ' + type },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'images-wrap',
	              ref: function ref(wrap) {
	                return _this5.imageContainer = wrap;
	              }
	            },
	            images.map(function (each, key) {
	              return _react2.default.createElement(
	                'div',
	                {
	                  ref: function ref(el) {
	                    _this5.imageRefs.push(el);
	                  },
	                  onLoad: key === 0 ? _this5.getImageDim : null,
	                  'data-index': key,
	                  key: key
	                },
	                _react2.default.createElement('img', { alt: '', src: each })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'nav', onClick: function onClick() {
	              return _this5.fadeImages('next');
	            } },
	          ' ',
	          '>',
	          ' '
	        )
	      );
	    }
	  }, {
	    key: 'fadeImages',
	    value: function fadeImages(type) {
	      var _this6 = this;
	
	      var images = this.state.images;
	
	      var newImageArr = [];
	      clearTimeout(this.timeout);
	      var lastImage = this.imageContainer.children[images.length - 1];
	      if (type === 'prev') {
	        newImageArr = images.slice(1);
	        newImageArr.splice(newImageArr.length - 1, 0, images[0]);
	        this.setState({ images: newImageArr });
	        newImageArr = images.slice(1, images.length);
	        newImageArr.splice(newImageArr.length, 0, images[0]);
	      } else {
	        newImageArr = [images[images.length - 1]].concat(images.slice(0, images.length - 1));
	      }
	      lastImage.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
	      lastImage.style.opacity = '0';
	      lastImage.style.transform = 'scale(' + this.props.scale + ')';
	      setTimeout(function () {
	        lastImage.style.opacity = '1';
	        lastImage.style.transform = 'scale(1)';
	        lastImage.style.transition = 'none';
	        _this6.timeout = setTimeout(function () {
	          return _this6.fadeImages('next');
	        }, _this6.props.duration);
	        _this6.setState({ images: newImageArr });
	      }, this.props.transitionDuration);
	    }
	  }]);
	
	  return Zoom;
	}(_react.Component);
	
	Zoom.defaultProps = {
	  duration: 5000,
	  transitionDuration: 1000
	};
	
	Zoom.propTypes = {
	  images: _propTypes2.default.array.isRequired,
	  duration: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number,
	  scale: _propTypes2.default.string.isRequired
	};
	exports.default = Zoom;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slide = __webpack_require__(468);
	
	Object.defineProperty(exports, 'Slide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slide).default;
	  }
	});
	
	var _fade = __webpack_require__(467);
	
	Object.defineProperty(exports, 'Fade', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fade).default;
	  }
	});
	
	var _zoom = __webpack_require__(469);
	
	Object.defineProperty(exports, 'Zoom', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_zoom).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlideshowImage = __webpack_require__(470);
	
	var _sign = __webpack_require__(500);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _table = __webpack_require__(501);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _garden = __webpack_require__(496);
	
	var _garden2 = _interopRequireDefault(_garden);
	
	var _desk = __webpack_require__(494);
	
	var _desk2 = _interopRequireDefault(_desk);
	
	var _flower = __webpack_require__(495);
	
	var _flower2 = _interopRequireDefault(_flower);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideShow = function SlideShow() {
	  return _react2.default.createElement(_reactSlideshowImage.Slide, {
	    images: [_sign2.default, _table2.default, _garden2.default, _desk2.default, _flower2.default],
	    duration: 4000,
	    transitionDuration: 500 });
	};
	
	exports.default = SlideShow;
	module.exports = exports['default'];

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/desk.8acc34a0.jpg";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/flower.b3039948.jpg";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/garden.ac0221fa.jpg";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sign.9f7da4b2.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/table.fdeecdaf.jpg";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 600px;\n  margin: 2rem auto 0;\n'], ['\n  max-width: 600px;\n  margin: 2rem auto 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SlideShow = __webpack_require__(207);
	
	var _SlideShow2 = _interopRequireDefault(_SlideShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SlideShowContainer = _styledComponents2.default.aside(_templateObject);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Welcome'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Chiropractic has been available in the UK for approximately sixty years but is still a relatively new alternative to orthodox medicine. In America (the birthplace of chiropractic) this treatment is already well established and accepted as a viable form of complimentary medicine for the whole family.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At Bristol Chiropractor we specialise in the McTimoney Chiropractic technique which concentrates on aligning the spine and skeletal joints through the means of a gentle low force technique.'
	    ),
	    _react2.default.createElement(
	      SlideShowContainer,
	      null,
	      _react2.default.createElement(_SlideShow2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7eaf777f99b9409063b7.js